import m from 'mithril';
import ArticleRecordComponent from './article'
import {
    Dialog,
} from 'components'

export default class GoHistory {
    view({
        attrs
    }) {
        return m(".position-fixed.d-inline-block", {
            style: {
                bottom: "15px",
                left: "15px",
                zIndex: 2025,
            }
        }, [
            m(".d-inline-block.pr-2", [
                m(".p-2.d-flex.justify-content-center.align-items-center", {
                    style: {
                        zIndex: 2025,
                        minWidth: "50px",
                        minHeight: "50px",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        borderRadius: "25px",
                        cursor: "pointer",
                    },
                    onclick: (e) => {
                        e.preventDefault()
                        Dialog.show(ArticleRecordComponent, {
                            attrs: {
                                onFix: () => {
                                    window.goGPT = true
                                    setTimeout(() => {
                                        m.route.set("/")
                                    }, 200)

                                }
                            }
                        })
                    }
                }, [
                    m("i.fa.fa-history", {
                        style: {
                            fontSize: "2.2rem",
                            color: "#FFFFFF"
                        }
                    })
                ])
            ]),
        ])
    }
}